import { ChannelType } from '../../types/channelTypes';

export type LocalStorageItem = {
    /**
     * 포스트 새글 작성 중 임시 데이터
     */
    editorDraft: {
        keyParams?: {
            channelType: ChannelType;
        };
        value: {
            title: string;
            content: string;
        };
    };
    /**
     * 마지막 읽은 브리프의 날짜
     */
    lastReadBriefDate: {
        keyParams?: {};
        value: string;
    };
};

export type LocalStorageItemKey = keyof LocalStorageItem;

const getItem = <T extends LocalStorageItemKey>({
    key,
    keyParams,
}: {
    key: T;
    keyParams?: LocalStorageItem[T]['keyParams'];
}): LocalStorageItem[T]['value'] | null => {
    const itemKey = createItemKey(key, keyParams);
    const valueStr = localStorage.getItem(itemKey);

    if (!valueStr) {
        return null;
    }

    try {
        const value = JSON.parse(valueStr) as LocalStorageItem[T]['value'];
        return value;
    } catch (error) {
        console.error(error);
    }

    return null;
};

const createItemKey = <T extends LocalStorageItemKey>(
    key: T,
    keyParams?: LocalStorageItem[T]['keyParams'],
) => {
    const paramStr = keyParams ? `:${JSON.stringify(keyParams)}` : '';
    return `${key}${paramStr}`;
};

const setItem = <T extends LocalStorageItemKey>({
    key,
    keyParams,
    value,
}: {
    key: T;
    keyParams?: LocalStorageItem[T]['keyParams'];
    value: LocalStorageItem[T]['value'];
}) => {
    try {
        const itemKey = createItemKey(key, keyParams);
        localStorage.setItem(itemKey, JSON.stringify(value));
    } catch (error) {
        console.error(error);
    }
};

const deleteItem = <T extends LocalStorageItemKey>({
    key,
    keyParams,
}: {
    key: T;
    keyParams?: LocalStorageItem[T]['keyParams'];
}) => {
    const itemKey = createItemKey(key, keyParams);
    localStorage.removeItem(itemKey);
};

export default {
    getItem,
    setItem,
    deleteItem,
};
